import { useProvider } from '@adobe/react-spectrum';

export const useSpectrumThemeProvider = useProvider;

export default useSpectrumThemeProvider;
